module.exports = __webpack_public_path__ + "img/1242554200.e4f7f3ac.jpg";